import Vue from 'vue'
import { VInput, VTextField } from 'vuetify/lib/components'

const GenericStringSingleLineFieldViewInput = Vue.extend({
  name: 'GenericStringSingleLineFieldViewInput',
  extends: VTextField,
  inject: ['isFormStatic'],
  props: {
    hideDetails: {
      type: Boolean,
      default: false,
    },
    assignGenericViewClass: {
      type: Boolean,
      default: false,
    },
    isFormStaticProp: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    validateOnInput: {
      type: Boolean,
      default: false,
    },
    fieldType: {
      type: String,
      default: 'text',
      validator: value => ['text', 'number', 'email'].includes(value),
    },
  },
  data() {
    return {
      internalRules: [
        // Convert any non-function rules to functions
        ...this.rules.map(rule => {
          if (typeof rule === 'function') return rule
          return () => rule
        }),
        // Add validation based on field type
        value => {
          if (!value) return true // Skip validation if empty

          if (this.fieldType === 'number') {
            return /^\d+$/.test(value) || 'This entry can only contain numbers'
          }

          if (this.fieldType === 'email') {
            const emailRegex =
              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            return (
              emailRegex.test(value) || 'Please enter a valid email address'
            )
          }

          return true
        },
      ],
      errorBucket: [],
    }
  },
  computed: {
    classes() {
      return {
        ...VTextField.options.computed.classes.call(this),
        'generic-text-field-view__input-field': true,
      }
    },
    outlined() {
      return this.isFormStatic.value || this.isFormStaticProp
    },
    isSubmittable() {
      return this.validateOnInput
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        // Only restrict input in submittable view for number fields
        if (
          this.isSubmittable &&
          this.fieldType === 'number' &&
          newValue !== null &&
          newValue !== undefined
        ) {
          const stringValue = String(newValue)
          if (!/^\d*$/.test(stringValue)) {
            this.$nextTick(() => {
              this.$emit('input', stringValue.replace(/[^\d]/g, ''))
            })
          }
        }
        if (this.validateOnInput) {
          this.validate()
        }
      },
    },
  },
  mounted() {
    // Add blur event listener
    this.$el.addEventListener('blur', this.onBlur)
  },
  beforeDestroy() {
    // Remove blur event listener
    this.$el.removeEventListener('blur', this.onBlur)
  },
  methods: {
    validate() {
      this.$nextTick(() => {
        const errors = []
        this.internalRules.forEach(rule => {
          const result = rule(this.value)
          if (typeof result === 'string') {
            errors.push(result)
          }
        })

        this.errorBucket = errors
        const isValid = errors.length === 0
        this.$emit('validation', isValid)
      })
    },
    onBlur() {
      if (this.fieldType === 'email') {
        this.validate()
      }
    },
  },
  render(h) {
    if (this.assignGenericViewClass)
      return h('div', { class: 'generic-text-field-view' }, [
        VInput.options.render.call(this, h),
      ])
    return VInput.options.render.call(this, h)
  },
})

delete GenericStringSingleLineFieldViewInput.options.props.outlined

export default GenericStringSingleLineFieldViewInput
